import React from 'react'
import { Checkbox } from '@material-ui/core'

const CheckboxWrapper = ({ ...overrides }) => {
  const checkboxConfig = {
    checked: false,
    color: 'primary',
    disabled: false,
    size: 'medium',
    ...overrides
  }

  return <Checkbox {...checkboxConfig} />
}

export default CheckboxWrapper
